// extracted by mini-css-extract-plugin
module.exports = {"uploadMedia":"UploadMedia_uploadMedia__sTJTl","notificationContainer":"UploadMedia_notificationContainer__3ZZgZ"};